





































import { Component, Prop, Vue } from "vue-property-decorator";
import { IUser } from "@/@types/admin/user/user";
import { IOrder } from "@/@types/orders/new-order";
import { IVirtualRooma } from "@/@types/hotel/virtual_rooms";
import { ICoast } from "@/@types/_shared/coast";
import { IReason } from "@/@types/orders/reason";
import { ICategory, IProductCard } from "@/@types/menu/menu/menu";

import BarOrderMenuSlidebar from "./bar-order-menu-slidebar.vue";
import OrderCard from "./order-card.vue";
import OrderConstructoprHeader from "./order-constructopr-header.vue";
import OrderConstructoprMain from "./order-constructopr-main.vue";
import OrderConstructoprFooter from "./order-constructopr-footer.vue";
import ChangeOrderStatus from "../change-order-status.vue";
import PromotionalCode from "../promotional-code.vue";

@Component({
  components: {
    OrderCard,
    PromotionalCode,
    ChangeOrderStatus,
    BarOrderMenuSlidebar,
    "order-header": OrderConstructoprHeader,
    "order-main": OrderConstructoprMain,
    "order-footer": OrderConstructoprFooter,
  },
})
export default class OrderConstructopr extends Vue {
  @Prop({ type: Object, default: null }) order!: IOrder;
  @Prop({ type: Array, default: () => [] }) orders!: Array<IOrder>;
  @Prop({ type: Array, default: () => [] }) menu!: Array<IProductCard>;
  @Prop({ type: Array, default: () => [] }) categorys!: Array<ICategory>;
  @Prop({ type: Array, default: () => [] }) vrooms!: Array<IVirtualRooma>;
  @Prop({ type: Array, default: () => [] }) reasons!: Array<IReason>;
  @Prop({ type: Object, default: null }) manager!: IUser;
  @Prop({ type: String, default: "" }) activeBar!: string;

  search = "";
  guest_id = "";

  get vroom(): IVirtualRooma | null {
    const vroom = this.vrooms.find((vr) => vr.room == this.order?.room_id);
    return vroom ? vroom : null;
  }

  get guestIndex(): number {
    if (!this.vroom) return -1;
    return this.vroom?.guests.findIndex((g) => g == this.guest_id);
  }

  get orderCoast(): string {
    let coast: { [x: string]: number } = {};
    this.order.cart.forEach((item) => {
      const coasts = Object.keys(coast);
      const itemcoast: ICoast = this.$getCoast(item.params.coast);
      if (!itemcoast) return;
      if (coasts.includes(itemcoast.currency))
        coast[itemcoast.currency] += item.count * itemcoast.value;
      else coast[itemcoast.currency] = item.count * itemcoast.value;
    });

    let result = "";
    Object.keys(coast).forEach((cost) => (result += `${coast[cost]} ${cost}`));
    return result;
  }

  adjustViewportHeight(): void {
    document.documentElement.style.setProperty(
      "--app-height",
      `${window.innerHeight}px`
    );
  }

  mounted(): void {
    this.$nextTick(() => {
      this.adjustViewportHeight();
      window.addEventListener("orientationchange", this.adjustViewportHeight);
    });
  }
}
